var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common common-form-inline" },
    [
      _vm.aprvStCd == 2
        ? _c("div", { staticClass: "apro-box" }, [
            _vm._v("审核意见："),
            _c("div", [_vm._v(_vm._s(_vm.aproCheckInfo))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-form-model",
        {
          ref: "vertifyForm",
          attrs: {
            model: _vm.pageData,
            rules: _vm.vertifyRules,
            "label-col": _vm.labelCol,
            "wrapper-col": _vm.wrapperCol
          }
        },
        [
          _c("div", { staticClass: "common-title" }, [_vm._v("企业基本信息")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-main no-shadow" },
            [
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "企业名称", prop: "cstNm" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.pageData.cstNm,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "cstNm", $$v)
                              },
                              expression: "pageData.cstNm"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "社会信用代码", prop: "orgCode" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.pageData.orgCode,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "orgCode", $$v)
                              },
                              expression: "pageData.orgCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "企业联系电话", prop: "phone" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.pageData.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "phone", $$v)
                              },
                              expression: "pageData.phone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "所属行业", prop: "industryType" } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { disabled: _vm.readonly },
                              model: {
                                value: _vm.pageData.industryType,
                                callback: function($$v) {
                                  _vm.$set(_vm.pageData, "industryType", $$v)
                                },
                                expression: "pageData.industryType"
                              }
                            },
                            _vm._l(_vm.industryList, function(d) {
                              return _c(
                                "a-select-option",
                                {
                                  key: d.dctVal,
                                  attrs: {
                                    value: d.dctVal,
                                    label: d.dctValNm,
                                    title: d.dctValNm
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(d.dctValNm) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "企业规模", prop: "companyScale" } },
                        [
                          !_vm.readonly
                            ? _c(
                                "a-popover",
                                [
                                  _c("template", { slot: "content" }, [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "line-height": "18px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "从业人员300人以下的为中小微型企业。"
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                                        其中，从业人员100人及以上的为中型企业；"
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                                        从业人员10人及以上的为小型企业；"
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                                        从业人员10人及以下的为微型企业。"
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "hoverText" }, [
                                    _vm._v("企业规模")
                                  ])
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              attrs: { disabled: _vm.readonly },
                              model: {
                                value: _vm.pageData.companyScale,
                                callback: function($$v) {
                                  _vm.$set(_vm.pageData, "companyScale", $$v)
                                },
                                expression: "pageData.companyScale"
                              }
                            },
                            _vm._l(_vm.EntpSzList, function(d) {
                              return _c(
                                "a-select-option",
                                {
                                  key: d.dctVal,
                                  attrs: {
                                    value: d.dctVal,
                                    label: d.dctValNm,
                                    title: d.dctValNm
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(d.dctValNm) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: "企业分类", prop: "companyCategory" }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { disabled: _vm.readonly },
                              model: {
                                value: _vm.pageData.companyCategory,
                                callback: function($$v) {
                                  _vm.$set(_vm.pageData, "companyCategory", $$v)
                                },
                                expression: "pageData.companyCategory"
                              }
                            },
                            _vm._l(_vm.companyCategoryList, function(d) {
                              return _c(
                                "a-select-option",
                                {
                                  key: d.dctVal,
                                  attrs: {
                                    value: d.dctVal,
                                    label: d.dctValNm,
                                    title: d.dctValNm
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(d.dctValNm) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "注册地址", prop: "address" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c(
                                "div",
                                { staticClass: "spaceBetween" },
                                [
                                  _c("a-cascader", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      fieldNames: {
                                        label: "areaName",
                                        value: "areaCode",
                                        children: "children"
                                      },
                                      options: _vm.RgstPrvcList,
                                      "load-data": _vm.loadData,
                                      placeholder: "请选择",
                                      "change-on-select": "",
                                      disabled: _vm.readonly
                                    },
                                    on: { change: _vm.onChangeProv },
                                    model: {
                                      value: _vm.provCity,
                                      callback: function($$v) {
                                        _vm.provCity = $$v
                                      },
                                      expression: "provCity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("a-input", {
                                attrs: {
                                  maxLength: 50,
                                  placeholder: "请输入详细地址",
                                  disabled: _vm.readonly
                                },
                                model: {
                                  value: _vm.pageData.address,
                                  callback: function($$v) {
                                    _vm.$set(_vm.pageData, "address", $$v)
                                  },
                                  expression: "pageData.address"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.readonly
                                ? _c("span", { staticClass: "input-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        (_vm.pageData.address &&
                                          _vm.pageData.address.length) ||
                                          0
                                      ) + "/50"
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "通讯地址",
                            prop: "communicationAddress"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c(
                                "div",
                                { staticClass: "spaceBetween" },
                                [
                                  _c("a-cascader", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      fieldNames: {
                                        label: "areaName",
                                        value: "areaCode",
                                        children: "children"
                                      },
                                      options: _vm.RgstPrvcListCommun,
                                      "load-data": _vm.loadDataCommun,
                                      placeholder: "请选择",
                                      "change-on-select": "",
                                      disabled: _vm.readonly
                                    },
                                    on: { change: _vm.onChangeProvCommun },
                                    model: {
                                      value: _vm.provcommunicationCity,
                                      callback: function($$v) {
                                        _vm.provcommunicationCity = $$v
                                      },
                                      expression: "provcommunicationCity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("a-input", {
                                attrs: {
                                  maxLength: 50,
                                  placeholder: "请输入详细地址",
                                  disabled: _vm.readonly
                                },
                                model: {
                                  value: _vm.pageData.communicationAddress,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pageData,
                                      "communicationAddress",
                                      $$v
                                    )
                                  },
                                  expression: "pageData.communicationAddress"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.readonly
                                ? _c("span", { staticClass: "input-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        (_vm.pageData.communicationAddress &&
                                          _vm.pageData.communicationAddress
                                            .length) ||
                                          0
                                      ) + "/50"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.readonly
                                ? _c(
                                    "div",
                                    { staticClass: "check-address" },
                                    [
                                      _c(
                                        "a-checkbox",
                                        {
                                          on: {
                                            change: _vm.setProvcommunicationCity
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            同注册地址\n                                        "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "营业执照照片", required: "" } },
                        [
                          _c("imgUpload", {
                            attrs: {
                              disabled: _vm.readonly,
                              file: _vm.getFile("1"),
                              paramObj: _vm.paramObj1,
                              name: "file"
                            },
                            on: { remove: _vm.removeOk, uploadOk: _vm.uploadOk }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: "营业期限", prop: "businessHoursSd" }
                        },
                        [
                          _c("start-end-date", {
                            ref: "startEndDate1",
                            attrs: { disabled: _vm.readonly }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "common-title" }, [
            _vm._v("法定代表人信息")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-main no-shadow" },
            [
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "法人姓名", prop: "lglpsnNm" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.pageData.lglpsnNm,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "lglpsnNm", $$v)
                              },
                              expression: "pageData.lglpsnNm"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "法人证件类型",
                            prop: "legalPersonCertificateType"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { disabled: _vm.readonly },
                              model: {
                                value: _vm.pageData.legalPersonCertificateType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.pageData,
                                    "legalPersonCertificateType",
                                    $$v
                                  )
                                },
                                expression:
                                  "pageData.legalPersonCertificateType"
                              }
                            },
                            _vm._l(_vm.LegalPersonCertTypeList, function(d) {
                              return _c(
                                "a-select-option",
                                {
                                  key: d.dctVal,
                                  attrs: {
                                    value: d.dctVal,
                                    label: d.dctValNm,
                                    title: d.dctValNm
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(d.dctValNm) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: "法人证件号码", prop: "lglpsnCrdtNo" }
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.pageData.lglpsnCrdtNo,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "lglpsnCrdtNo", $$v)
                              },
                              expression: "pageData.lglpsnCrdtNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "有效期限",
                            prop: "legalPersonCertificateSd"
                          }
                        },
                        [
                          _c("start-end-date", {
                            ref: "startEndDate2",
                            attrs: { disabled: _vm.readonly }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "法人证件照片",
                            rules: { required: true }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "spaceLeft",
                              staticStyle: { width: "500px" }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("imgUpload", {
                                    attrs: {
                                      disabled: _vm.readonly,
                                      file: _vm.getFile("2"),
                                      paramObj: _vm.paramObj2,
                                      text: "上传证件正面",
                                      name: "file"
                                    },
                                    on: {
                                      remove: _vm.removeOk,
                                      uploadOk: _vm.uploadOk
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("imgUpload", {
                                    attrs: {
                                      disabled: _vm.readonly,
                                      file: _vm.getFile("3"),
                                      paramObj: _vm.paramObj3,
                                      text: "上传证件背面",
                                      name: "file"
                                    },
                                    on: {
                                      remove: _vm.removeOk,
                                      uploadOk: _vm.uploadOk
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "common-title" }, [_vm._v("基本账户信息")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-main no-shadow" },
            [
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "基本账户号", prop: "basicAccNo" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.pageData.basicAccNo,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "basicAccNo", $$v)
                              },
                              expression: "pageData.basicAccNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: "基本开户行", prop: "basicAccName" }
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.pageData.basicAccName,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "basicAccName", $$v)
                              },
                              expression: "pageData.basicAccName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "基本户开户许可证",
                            rules: { required: true }
                          }
                        },
                        [
                          _c("imgUpload", {
                            attrs: {
                              file: _vm.getFile("9"),
                              paramObj: _vm.paramObj9,
                              disabled: _vm.readonly,
                              name: "file"
                            },
                            on: { remove: _vm.removeOk, uploadOk: _vm.uploadOk }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "大额行号", prop: "largeBankNo" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.pageData.largeBankNo,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "largeBankNo", $$v)
                              },
                              expression: "pageData.largeBankNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "common-title" }, [_vm._v("管理员信息")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-main no-shadow" },
            [
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "管理员姓名", prop: "mnpltPsnNm" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.pageData.mnpltPsnNm,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "mnpltPsnNm", $$v)
                              },
                              expression: "pageData.mnpltPsnNm"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "管理员身份证",
                            prop: "mnpltPsnCrdtNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.pageData.mnpltPsnCrdtNo,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "mnpltPsnCrdtNo", $$v)
                              },
                              expression: "pageData.mnpltPsnCrdtNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "有效期限",
                            prop: "operatorIdNumberSd"
                          }
                        },
                        [
                          _c("start-end-date", {
                            ref: "startEndDate3",
                            attrs: { disabled: _vm.readonly }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "管理员电话", prop: "ctcPsnTel" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.pageData.ctcPsnTel,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "ctcPsnTel", $$v)
                              },
                              expression: "pageData.ctcPsnTel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "管理员身份证照片",
                            rules: { required: true }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "spaceLeft",
                              staticStyle: { width: "600px" }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("imgUpload", {
                                    attrs: {
                                      file: _vm.getFile("4"),
                                      disabled: _vm.readonly,
                                      paramObj: _vm.paramObj4,
                                      text: "正面",
                                      name: "file"
                                    },
                                    on: {
                                      remove: _vm.removeOk,
                                      uploadOk: _vm.uploadOk
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("imgUpload", {
                                    attrs: {
                                      file: _vm.getFile("5"),
                                      disabled: _vm.readonly,
                                      paramObj: _vm.paramObj5,
                                      text: "反面",
                                      name: "file"
                                    },
                                    on: {
                                      remove: _vm.removeOk,
                                      uploadOk: _vm.uploadOk
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("imgUpload", {
                                    attrs: {
                                      file: _vm.getFile("10"),
                                      disabled: _vm.readonly,
                                      paramObj: _vm.paramObj10,
                                      text: "管理员手持身份证照片",
                                      name: "file"
                                    },
                                    on: {
                                      remove: _vm.removeOk,
                                      uploadOk: _vm.uploadOk
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    top: "30px"
                                  },
                                  on: { click: _vm.openExample }
                                },
                                [_vm._v("示例")]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "授权委托书",
                            rules: { required: true }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "spaceLeft",
                              staticStyle: { width: "600px" }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("imgUpload", {
                                    attrs: {
                                      file: _vm.getFile("7"),
                                      disabled: _vm.readonly,
                                      paramObj: _vm.paramObj7,
                                      name: "file"
                                    },
                                    on: {
                                      remove: _vm.removeOk,
                                      uploadOk: _vm.uploadOk
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    top: "30px"
                                  },
                                  attrs: {
                                    href: "javascript:void(0)",
                                    download: "授权委托书_企业认证.doc"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.fileDownload()
                                    }
                                  }
                                },
                                [_vm._v("授权委托书(企业认证)模板下载")]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "model-footer-btns spaceCenter" },
        [
          _c(
            "a-button",
            { staticClass: "btn-blue-line btn-big", on: { click: _vm.goback } },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  attrs: { type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v("保存")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  attrs: { type: "primary" },
                  on: { click: _vm.submit }
                },
                [_vm._v("提交")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("imgView", {
        ref: "imgViewAprov",
        attrs: { src: "/static/images/example.png" }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-left": "12%" } }, [
      _c("p", [
        _vm._v(
          "认证信息填写完成后请将下述纸质资料邮寄至我司，我司在收到资料后将尽快审核您的认证申请。"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flexStart" }, [
        _c("div", [
          _c("p", [_vm._v("邮寄资料清单：")]),
          _c("span", { staticClass: "text-color-orange" }, [
            _vm._v("(均需加盖企业公章)")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-left": "15px" } }, [
          _c("ul", { staticClass: "ver-li" }, [
            _c("li", [_vm._v("1. 营业执照复印件")]),
            _vm._v(" "),
            _c("li", [_vm._v("2. 开户许可证复印件")]),
            _vm._v(" "),
            _c("li", [_vm._v("3. 法人身份证正反面复印件")]),
            _vm._v(" "),
            _c("li", [_vm._v("4. 管理员身份证正反面复印件")]),
            _vm._v(" "),
            _c("li", [_vm._v("5. 管理员手持身份证照片打印件")]),
            _vm._v(" "),
            _c("li", [_vm._v("6. 授权委托书原件")])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "地址：河南省南阳市卧龙区七里园乡美盛白河湾商业楼44号楼106号"
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("收件人：彭松　　电话：15290365751")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-260f25fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-260f25fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/security/vertify/vertify.vue
// module id = hgvC
// module chunks = 1